import React from 'react';
import { useAuth } from '../../contexts/authContext';
import { useNavigate } from 'react-router-dom';
import './../styles/ProfileButton.css';
import { FaUser } from 'react-icons/fa';
import { useLanguage } from "../../contexts/LanguageContext";

export const translations = {
  kz: {
    login: "Кіру",
    profile: "Профиль"
  },
  ru: {
    login: "Войти",
    profile: "Профиль"
  },
  en: {
    login: "Sign in",
    profile: "Profile"
  }
}

const ProfileButton = ({ className = '', variant = 'default' }) => {
  const { checkAuth, isAuthenticated, admin, user } = useAuth();
  const navigate = useNavigate();

  const { currentLanguage } = useLanguage();
  const t = translations[currentLanguage] || translations.kz;

  const handleProfileClick = () => {
    // Проверяем авторизацию
    const isAuth = checkAuth();

    if (isAuth || isAuthenticated) {
      // Если пользователь авторизован, перенаправляем на профиль
      navigate('/profile');
    } else {
      // Если не авторизован, перенаправляем на страницу входа
      navigate('/login');
    }
  };

  // Определяем имя пользователя для отображения
  const getUserName = () => {
    if (admin) {
      return admin.name;
    } else if (user) {
      return `${user.firstName} ${user.lastName}`;
    }
    return 'Профиль';
  };

  // Различные варианты кнопки
  const getButtonContent = () => {
    switch (variant) {
      case 'icon':
        return (
          <>
            <div className="profile-icon">
              {isAuthenticated && user?.avatar_url
                ? <img src={process.env.REACT_APP_API_URL + user.avatar_url} alt="avatar" />
                : <FaUser />}
            </div>
          </>
        );
      case 'full':
        return (
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <div className="profile-icon">
              {isAuthenticated && user?.avatar_url
                ? <img src={process.env.REACT_APP_API_URL + user.avatar_url} alt="avatar" />
                : <FaUser />}
            </div>

            <span className="profile-text">
              {isAuthenticated ? getUserName() : t.login}
            </span>
          </div>
        );
      default:
        return (
          <>
              <span className="profile-icon"><FaUser /></span>
              <span className="profile-text">{t.profile}</span>
            </>
        );
    }
  };

  return (
    <button
      onClick={handleProfileClick}
      className={`profile - button ${variant} ${className} ${isAuthenticated ? 'authenticated' : 'unauthenticated'} `}
      title={isAuthenticated ? 'Перейти в профиль' : 'Войти в систему'}
    >
      {getButtonContent()}
    </button>
  );
};

export default ProfileButton;